module.exports = __webpack_public_path__ + "static/media/SAW-Logo_grau-negativ_RGB.c66794ef.svg";